import {Component, OnDestroy, OnInit} from '@angular/core';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { Subscription } from 'rxjs';
import { AccountService, EventManager } from 'src/app/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { CRM_FMARKET_SALE_LEAD_ROUTES, CRM_FMARKET_SALE_ROUTES, CRM_LIFE_HERO_SALE_ROUTES } from './side-nav-routes.config';
import { AppQueries } from 'src/app/state';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sidenav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss']
})

export class SideNavComponent implements OnInit, OnDestroy {
    public menuItems: any[];
    isFolded: boolean;
    isSideNavDark: boolean;
    subscriptions?: Subscription[] = [];
    total: number = 0;
    isSaleLead: boolean
    totalSupport: number = 0;
    totalForeignInvestor: number = 0;
    totalAssignedToOrg: number = 0;
    totalNotAssignedToOrg: number = 0;
    constructor( 
        private sessionStorageService: SessionStorageService,
        private localStorage$: LocalStorageService, 
        public eventManager: EventManager,
        private accountService: AccountService,
        private appQueries: AppQueries,
        private router: Router,
        private themeService: ThemeConstantService
    ) {}

    ngOnInit(): void {
        this.appQueries.userProfile$
        .subscribe((userProfile) => {
            if (userProfile && userProfile.id) {
                this.isSaleLead = userProfile.isSaleLead;
                let tab = this.localStorage$.retrieve('TAB_MENU') || 'FMARKET';
                let isFocusRouter: boolean = false;
                if (tab === 'LIFE_HERO' && !this.isSaleLead) {
                   isFocusRouter = true;
                   tab = 'FMARKET';
                }
                this.changeTab(tab, isFocusRouter);
            }
        });
        this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
        this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
        this.total = this.sessionStorageService.retrieve('totalTransactions');
        this.totalSupport = this.sessionStorageService.retrieve('totalSupport');
        this.totalForeignInvestor = this.sessionStorageService.retrieve('totalForeignInvestor');
        this.subscriptions = [
            this.eventManager.subscribe('get-transactions', (res) => {
                this.total = res.content.total || [];
            }),
            this.eventManager.subscribe('get-support-list', (res) => {
                this.totalSupport = res.content.totalSupport || [];
            }),
            this.eventManager.subscribe('get-total-foreign-investor', (res) => {
                this.totalForeignInvestor = res.content.total || [];
            }),
            this.eventManager.subscribe('change-crm', (res) => {
                const tab = res.content.tab;
                this.localStorage$.store('TAB_MENU', tab);
                this.changeTab(tab, true);
            }),
            this.eventManager.subscribe('summary-life-hero', (res) => {
                this.totalAssignedToOrg = res.content.assignedToOrg || 0;
                this.totalNotAssignedToOrg = res.content.notAssignedToOrg || 0;
            }),
            
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions.length > 0) {
          this.eventManager.destroys(this.subscriptions);
        }
    }
    changeTab(tab, isFocusRouter?) {
        this.localStorage$.store('TAB_MENU', tab);
        let routers = [];
        switch (tab) {
            case 'FMARKET':
                routers = CRM_FMARKET_SALE_LEAD_ROUTES;
                this.menuItems = routers.filter(menuItem => menuItem);
                if (isFocusRouter) {
                    this.router.navigate(['users/investor/all']);
                }
                
            break;
            case 'LIFE_HERO':
                routers = CRM_LIFE_HERO_SALE_ROUTES;
                this.menuItems = routers.filter(menuItem => menuItem);
                if (isFocusRouter) {
                    this.router.navigate(['life-hero/request-assistance']);
                }
            break;
        }
    }
}
